import { PlatformEnv } from './types';
import BaseSensorsConfig from './BaseSensorsConfig';

export default class BaseConfig {
  system_code: string = ''; // 必传，系统编码、项目组编码：由于客渠共用同一个神策项目，用这个区分不同项目组的数据

  product_code: string = ''; // 必传，项目名称，用来区分前端项目，单项目仓库传：git项目名称，多项目仓库传：git项目名称_项目关键字

  platform_env: PlatformEnv = PlatformEnv.dev; // 必传，用来区分平台环境。dev=开发环境,sit=测试环境,pre=预发布环境,prod=生产环境

  app_version?: string; // 业务项目版本号

  show_log: boolean = false; // 是否打印神策日志

  server_url?: string = 'https://ubs.sf-express.com/sa?project=entercust'; // 神策上传地址，默认为客渠上传地址

  channel_keys?: string[] = ['cid', 'channelCode', 'source', 'qrSource']; // 非必传，渠道参数，可以传多个

  plugins?: Record<string, object | boolean>;

  sensorsConfig: BaseSensorsConfig = new BaseSensorsConfig();

  mergeConfig(config: BaseConfig) {
    this.system_code = config.system_code;
    this.product_code = config.product_code;
    this.platform_env = config.platform_env;
    this.app_version = config.app_version || '1.0.0';
    this.server_url = config.server_url || this.server_url;
    this.show_log = config.show_log === undefined ? this.show_log : config.show_log;
    this.channel_keys =
      Array.isArray(config.channel_keys) && config.channel_keys.length > 0 ? config.channel_keys : this.channel_keys;

    this.sensorsConfig = {
      ...this.sensorsConfig,
      ...config.sensorsConfig,
      show_log: this.show_log,
      server_url: this.server_url,
      source_channel: this.channel_keys,
    };

    this.plugins = { ...this.plugins, ...config.plugins };
  }
}
